<template>

  <div class="ml-0 lg:ml-12 mt-2 lg:mt-32">

    <div ref="observerElement">
      <transition name="fade-slide-up" appear v-if="isVisible">
        <div class=" font-futura text-navy text-5xl mt-32 text-center lg:text-left lg:text-7xl">
          <p>HANGA</p>
          <p>IS ORGANIZED BY</p>
        </div>
      </transition>
    </div>



    <!-- first section -->
    <div class="flex flex-wrap gap-y-12 gap-x-8 lg:gap-x-16 px-4 lg:px-2 mt-24">
      <!-- MINICT -->
      <div class="w-full sm:w-1/2 lg:w-auto fade-in space-y-4 text-left" ref="item1">
        <img src="../assets/coat.svg" class="max-w-[150px] sm:max-w-[180px] lg:max-w-[200px]">
        <hr class="border-t border-gray-300">
        <div>
          <p class="font-futura text-3xl sm:text-6xl md:text-7xl lg:text-4xl text-navy">MINICT</p>
          <p class="text-lightblue font-gramatika text-lg sm:text-xl">The Ministry of ICT and Innovation</p>
        </div>
      </div>

      <!-- UNDP -->
      <div class="w-full sm:w-1/2 lg:w-auto fade-in space-y-4 text-left" ref="item3">
        <img src="../assets/undp.svg" class="max-w-[150px] sm:max-w-[180px] lg:max-w-[200px]">
        <hr class="border-t border-gray-300">
        <div>
          <p class="font-futura text-3xl sm:text-6xl md:text-7xl lg:text-4xl text-navy">UNDP</p>
          <p class="text-lightblue font-gramatika text-lg sm:text-xl">United Nations Development Programme in Rwanda</p>
        </div>
      </div>
    </div>

    <!-- " <div
      class="flex flex-wrap justify-center  lg:mr-4 sm:mr-0 lg:justify-between gap-y-12 gap-x-8 lg:gap-x-16 px-4 lg:px-2 mt-24">
      <div class="w-full sm:w-1/2 lg:w-1/4 fade-in space-y-4 text-center lg:text-left" ref="item1">
        <img src="../assets/coat.svg" class="max-w-[150px] sm:max-w-[180px] lg:max-w-[200px] mx-auto lg:mx-0">
        <hr class="border-t border-gray-300  mx-auto lg:mx-0">
        <div>
          <p class="font-futura text-3xl sm:text-6xl md:text-7xl lg:text-4xl text-navy">MINICT</p>
          <p class="text-lightblue font-gramatika text-lg sm:text-xl">The Ministry of ICT and Innovation</p>
        </div>
      </div>

      <div class="w-full sm:w-1/2 lg:w-1/4 fade-in mt-0 lg:mt-16 space-y-4 text-center lg:text-left" ref="item2">
        <img src="../assets/rdb.svg" class="max-w-[150px] sm:max-w-[180px] lg:max-w-[200px] mx-auto lg:mx-0">
        <hr class="border-t border-gray-300  mx-auto lg:mx-0">
        <div>
          <p class="font-futura text-3xl sm:text-4xl md:text-3xl lg:text-4xl text-navy">RDB</p>
          <p class="text-lightblue font-gramatika text-lg sm:text-xl">Rwanda Development Board</p>
        </div>
      </div>

      <div class="w-full sm:w-1/2 lg:w-1/4 fade-in space-y-4 text-center lg:text-left" ref="item3">
        <img src="../assets/undp.svg" class="max-w-[150px] sm:max-w-[180px] lg:max-w-[200px] mx-auto lg:mx-0">
        <hr class="border-t border-gray-300  mx-auto lg:mx-0">
        <div>
          <p class="font-futura text-3xl sm:text-6xl md:text-7xl lg:text-4xl text-navy">UNDP</p>
          <p class="text-lightblue font-gramatika text-lg sm:text-xl">United Nations Development Programme in Rwanda</p>
        </div>
      </div>
    </div>" -->



    <!-- second section -->
    <div ref="observerElement1">
      <div
        class="ml-4 mr-4 xl:mt-4 2xl:-mt-12 mlg:mr-10 md:ml-2 flex flex-col md:flex-row lg:space-x-16 items-start justify-between">

        <div class="flex-1  mt-12 xl:mt-2 2xl:mt-60 md:mt-8 max-w-full md:max-w-[50%]">

          <div class="space-y-2  md:mt-48 ">
            <transition name="fade-slide-up" appear v-if="isVisible1">
              <div>
                <p class="text-4xl md:text-7xl font-futura text-navy">BUILDING RWANDA'S </p>
                <p class="text-4xl md:text-7xl font-futura text-navy">INNOVATION ECOSYSTEM</p>
              </div>
            </transition>
          </div>

          <div class="mt-10">
            <div class="text-justify space-y-12 w-full">
              <transition name="fade-slide-left" appear v-if="isVisible1">
                <p class="text-navy font-gramatika text-lg md:text-md">
                  "We are delighted, as Jasiri, to be part of Hanga Pitchfest,
                  We believe in the power of entrepreneurship to transform our society and Hanga Pitchfest calls for
                  action for
                  those seeking to challenge the status quo and build solutions that will improve the lives of many."
                  - Aline Kabanda, East Africa Regional Director, Jasiri.
                </p>
              </transition>


            </div>
          </div>
        </div>

        <transition name="fade-slide-right" appear v-if="isVisible1">
          <div class="flex-1 h-[300px] sm:mt-10 md:h-auto  md:mt-10 xl:mt-36 2xl:mt-52 max-w-full md:max-w-[50%]">
            <img src="../assets/rwanda .svg" class="w-full mt-10 h-full  object-cover">
          </div>
        </transition>
      </div>
    </div>



    <!-- partnernship page  -->
    <div ref="observerElement2">

      <div class=" font-futura text-navy text-5xl mt-32 text-center lg:text-left lg:text-6xl">
        <transition name="fade-slide-up" appear v-if="isVisible2">
          <p>ALL PARTNERSHIPS</p>
        </transition>

      </div>




      <div class="grid grid-cols-2 ml-4 lg:ml-0  mr-4 lg:mr-12 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5  mt-12 ">
        <ul v-for="startup in filteredStartups" :key="startup.name"
          class=" border border-lightTangerine  p-4  h-[28vh]  ">
          <div class="flex items-center justify-center">
            <li>

              <transition name="fade-slide-up" appear>
                <img :src="startup.logo" alt="Logo" class="w-full h-12 mt-6  mb-4" />
              </transition>

              <transition name="fade-slide-right" appear>
                <h3 class="text-lg text-center font-gramatika text-navy text-lg mt-4 ">{{ startup.name }}</h3>
              </transition>

            </li>
          </div>

        </ul>

      </div>


    </div>

   <!-- Quotes Carousel Section -->
      <div class="ml-4 md:ml-12 mt-12 md:mt-32">
        <div class="mt-8 md:mt-12 md:ml-16 overflow-hidden relative">
          <!-- Carousel Container -->
          <div ref="quotesWrapper" class="flex transition-transform duration-500 ease-in-out">
            <!-- Quote 1 -->
            <div class="w-full flex-shrink-0 px-4">
              <div class="flex flex-col md:flex-row md:space-x-32">
                <div class="md:w-1/3 p-6">
                  <span class="font-futura text-tangerine text-5xl md:text-7xl">"</span>
                  <p class="text-navy text-2xl md:text-2xl font-gramatika font-medium -mt-6 md:-mt-8">
                    Like any other startup, we face challenges. But the exposure, network, and skills you gain through Hanga Pitchfest really prepare 
                    you for the next step—especially when it comes to starting your fundraising journey.
                  </p>
                  <div class="flex items-center mt-8">
                    <hr class="w-8 md:w-12 border-2 border-navy mr-2">
                    <p class="font-futura text-navy text-xl md:text-2xl">CEDRICK MUPENZI, SINC</p>
                  </div>
                </div>
                <div class="md:w-1/2 flex items-center justify-center">
                  <img src="../assets/sinc.png" class="max-h-[300px] md:max-h-[500px]">
                </div>
              </div>
            </div>
            
            <!-- Quote 2 -->
            <div class="w-full flex-shrink-0 px-4">
              <div class="flex flex-col md:flex-row md:space-x-32">
                <div class="md:w-1/3 p-6">
                  <span class="font-futura text-tangerine text-5xl md:text-7xl">"</span>
                  <p class="text-navy text-2xl md:text-2xl font-gramatika font-medium -mt-6 md:-mt-8">
                    One of the main challenges we had was being able to scale our production. Especially after winning Hanga Pitchfest—this is 
                    just a door, a small door that's propelling us to actually do it quickly. We've always had quality, but now the focus is 
                    on producing at scale and making it affordable for the people who need it most.
                  </p>
                  <div class="flex items-center mt-8">
                    <hr class="w-8 md:w-12 border-2 border-navy mr-2">
                    <p class="font-futura text-navy text-xl md:text-2xl">CYNTIA , LOOPA</p>
                  </div>
                </div>
                <div class="md:w-1/2 flex items-center justify-center">
                  <img src="../assets/looopaa.png" class="max-h-[300px] md:max-h-[500px]">
                </div>
              </div>
            </div>

            <!-- Quote 3 -->
            <div class="w-full flex-shrink-0 px-4">
              <div class="flex flex-col md:flex-row md:space-x-32">
                <div class="md:w-1/3 p-6">
                  <span class="font-futura text-tangerine text-5xl md:text-7xl">"</span>
                  <p class="text-navy text-2xl md:text-2xl font-gramatika font-medium -mt-6 md:-mt-8">
                    Winning Hanga Pitchfest has been a game-changer for Lifesten Health.It propelled us into the spotlight and opened doors to 
                    investors and esteemed clients, who were captivated by the impact that we could create together.
                  </p>
                  <div class="flex items-center mt-8">
                    <hr class="w-8 md:w-12 border-2 border-navy mr-2">
                    <p class="font-futura text-navy text-xl md:text-2xl">PEACE NDOLI, LIFESTEN HEALTH</p>
                  </div>
                </div>
                <div class="md:w-1/2 flex items-center justify-center">
                  <img src="../assets/lifestennn.png" class="max-h-[300px] md:max-h-[500px]">
                </div>
              </div>
            </div>

            <!-- Quote 4 -->
            <div class="w-full flex-shrink-0 px-4">
              <div class="flex flex-col md:flex-row">
                <div class="md:w-1/3 p-6">
                  <span class="font-futura text-tangerine text-5xl md:text-7xl">"</span>
                  <p class="text-navy text-2xl md:text-2xl font-gramatika font-medium -mt-6 md:-mt-8">
                    After Hanga Pitch Fest, we no longer work in the same way we used to. We have been enrolled in different training and have since 
                    improved the quality and appearance of our products. We still make lighting and Bluetooth players but with high quality.
                  </p>
                  <div class="flex items-center mt-4">
                    <hr class="w-8 md:w-12 border-2 border-navy mr-2">
                    <p class="font-futura text-navy text-lg md:text-xl">DIANE CYUZUZO, AFRIDUINO</p>
                  </div>
                </div>
                <div class="md:w-1/2 flex items-center justify-center">
                  <img src="../assets/Group 41.svg" class="max-h-[300px] md:max-h-[500px]">
                </div>
              </div>
            </div>
          </div>

          <!-- Navigation Buttons -->
          <div class="flex justify-between mt-8 px-4 mt:mr-8">
            <button @click="prevQuote" class="border-2 rounded-full p-3 bg-white text-navy hover:bg-navy hover:text-white">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
              </svg>
            </button>
            <button @click="nextQuote" class="border-2 rounded-full p-3 bg-white text-navy hover:bg-navy hover:text-white mr-16">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
            </button>
          </div>
        </div>
      </div>


  </div>
</template>

<script>
export default {
  name: "PartnersPage",

  data() {
    return {
      currentQuote: 0,
      totalQuotes: 3,
      isVisible: false,
      isVisible1: false,
      isVisible2: false,
      startX: 0,
      isDragging: false,
      scrollLeft: 0,
      startups: [
        { name: 'Pesa Choice', logo: require('../assets/partners/pesa.svg') },
        { name: 'Startups In Rwanda', logo: require('../assets/partners/startup.svg') },
        { name: 'Airtel', logo: require('../assets/partners/airtel.svg') },
        { name: 'AMI', logo: require('../assets/partners/ami.svg') },
        { name: 'Bank of Kigali', logo: require('../assets/partners/bk.svg') },
        { name: 'Bag', logo: require('../assets/partners/bag.svg') },
        { name: 'BPN', logo: require('../assets/partners/bpn.svg') },
        // { name: 'AOS', logo: require('../assets/partners/aos.svg') },
        { name: 'Canal Box', logo: require('../assets/partners/canal.svg') },
        { name: 'CMU', logo: require('../assets/partners/cmu.svg') },
        { name: 'AOS', logo: require('../assets/partners/aos.svg') },
        { name: 'Ejo Heza', logo: require('../assets/partners/ejo.svg') },
        { name: 'ESP', logo: require('../assets/partners/esp.svg') },
        { name: 'European Union', logo: require('../assets/partners/europe.svg') },
        { name: 'ICT chamber', logo: require('../assets/partners/ict.svg') },
        { name: 'GIZ', logo: require('../assets/partners/Giz.svg') },
        { name: 'Igihe', logo: require('../assets/partners/igihe.svg') },
        { name: 'Jasiri', logo: require('../assets/partners/jasiri.svg') },
        { name: 'QT', logo: require('../assets/partners/qt.svg') },
        { name: 'Mastercard Foundation', logo: require('../assets/partners/mc.svg') },
        { name: 'JICA', logo: require('../assets/partners/jica.svg') },
        { name: 'RISA', logo: require('../assets/partners/risa.svg') },
        { name: 'WOMEN UN', logo: require('../assets/partners/un.svg') },
        { name: 'Pindo', logo: require('../assets/partners/pindo.svg') },
        { name: 'KT Rwanda Networks', logo: require('../assets/partners/kt.svg') },
        { name: 'KudiBooks', logo: require('../assets/partners/kudi.svg') },
        // { name: 'RDB', logo: require('../assets/partners/rdb.svg') },
        { name: 'RSSB', logo: require('../assets/partners/rssb.svg') },
        { name: 'UNDP', logo: require('../assets/partners/undp.svg') },
      ]
    }
  },

  computed: {
    filteredStartups() {
      return this.startups.filter(startup => {
        const startupMatch = startup.name;
        return startupMatch;
      });
    }
  },

  mounted() {
    this.updateCarousel();
    window.addEventListener('resize', this.updateCarousel);
    this.setupIntersectionObserver();

    const targetId = this.$route.hash.substring(1);
    if (targetId) {
      const target = document.getElementById(targetId);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    this.initiativeAnimations();
    this.missoutAnimations();
    this.blogAnimations();
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.updateCarousel);
  },

  methods: {
    handleMouseDown(e) {
      this.isDragging = true;
      this.startX = e.pageX - this.$refs.scrollContainer.offsetLeft;
      this.scrollLeft = this.$refs.scrollContainer.scrollLeft;
      this.$refs.scrollContainer.style.cursor = 'grabbing';
    },

    handleMouseMove(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const x = e.pageX - this.$refs.scrollContainer.offsetLeft;
      const walk = (x - this.startX) * 2;
      this.$refs.scrollContainer.scrollLeft = this.scrollLeft - walk;
    },

    handleMouseUp() {
      this.isDragging = false;
      this.$refs.scrollContainer.style.cursor = 'grab';
    },

    handleTouchStart(e) {
      this.startX = e.touches[0].clientX;
    },

    handleTouchMove(e) {
      const distance = this.startX - e.touches[0].clientX;
      this.$refs.scrollContainer.scrollLeft += distance;
      this.startX = e.touches[0].clientX;
    },

    nextQuote() {
      this.currentQuote = (this.currentQuote + 1) % this.totalQuotes;
      this.updateCarousel();
    },

    prevQuote() {
      this.currentQuote = (this.currentQuote - 1 + this.totalQuotes) % this.totalQuotes;
      this.updateCarousel();
    },

    updateCarousel() {
      const wrapper = this.$refs.quotesWrapper;
      if (wrapper) {
        wrapper.style.transform = `translateX(-${this.currentQuote * 100}%)`;
      }
    },

    initiativeAnimations() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible = true;
          }
        });
      });

      if (this.$refs.observerElement) {
        observer.observe(this.$refs.observerElement);
      }
    },

    missoutAnimations() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible1 = true;
          }
        });
      });

      if (this.$refs.observerElement1) {
        observer.observe(this.$refs.observerElement1);
      }
    },

    blogAnimations() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible2 = true;
          }
        });
      }, {
        threshold: 0.5
      });

      if (this.$refs.observerElement2) {
        observer.observe(this.$refs.observerElement2);
      }
    },

    setupIntersectionObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('slide-up-visible');
            entry.target.classList.add('zoom-in-visible');
            entry.target.classList.add('fade-in-visible');
          }
        });
      });

      // Observe all elements with refs
      for (let key in this.$refs) {
        if (this.$refs[key]) {
          if (this.$refs[key].$el) {
            observer.observe(this.$refs[key].$el);
          } else {
            observer.observe(this.$refs[key]);
          }
        }
      }

      // Observe specific items
      const items = [this.$refs.item1, this.$refs.item2, this.$refs.item3];
      items.forEach(item => {
        if (item) observer.observe(item);
      });
    }
  }
}
</script>

<style>
.fade-in {
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.fade-in-visible {
  opacity: 1;
}

.fade-in:nth-child(1) {
  transition-delay: 0.3s;
}

.fade-in:nth-child(2) {
  transition-delay: 0.6s;
}

.fade-in:nth-child(3) {
  transition-delay: 0.9s;
}
</style>